import React, { useMemo, useContext } from 'react'
import PropTypes from 'prop-types'
import { Table } from 'semantic-ui-react'
import Moment from 'moment'
import styles from './Device.module.scss'
import Intensity from './Intensity'
import FragranceRemaining from './FragranceRemaining'
import { SessionContext } from '@radbse/auth-identity'
import { useMode, useCycle, useFragrancePercentRemaining, useStateCountryNames } from '../../hooks/device'
import { systemConfigurations } from '../../utilities/deviceHelpers'

const Device = ({ device, onClick }) => {
    const { user } = useContext(SessionContext)
    const isOEM = useMemo(() => user.role === 'OEM::Admin' || user.role === 'OEM::Observer', [user])

    const fragrancePercentRemaining = useFragrancePercentRemaining(device)
    const [mode, modeOn] = useMode(device)
    const cycle = useCycle(device)
    const { stateName, countryName } = useStateCountryNames(device)
    
    return (
        <Table.Row onClick={() => (onClick ? onClick(device.dsn) : null)}>
            <Table.Cell>
                {device.scenxus && (
                    <div>
                        {isOEM && (
                            <div>
                                <b>{device.scenxus.csp}</b>
                            </div>
                        )}

                        <div>
                            <b>{device.scenxus.customer}</b>
                        </div>
                        {device.scenxus.customerId && (
                            <div>
                                Customer ID: {device.scenxus.customerId}
                            </div>
                        )}
                        {device.scenxus.storeNumber && (
                            <div>
                                Store Number: {device.scenxus.storeNumber}
                            </div>
                        )}
                    </div>
                )}

                <div>{device.productName}</div>
                {device.scenxus && (
                    <div>
                        {device.scenxus.city}, {stateName}, {countryName}
                    </div>
                )}
            </Table.Cell>
            <Table.Cell>
                {device.scenxus && <div>Serial #: {device.scenxus.serialNumber}</div>}

                <div>DSN: {device.dsn}</div>
                {device.ssid && (
                    <div>
                        Network: {device.lanEnabled && <span>LAN</span>}
                        {!device.lanEnabled && <span>{device.ssid}</span>}
                    </div>
                )}
                {device.scenxus && <div>Sys. Config.: {systemConfigurations[device.scenxus.systemConfiguration]}</div>}
                {device.scenxus && <div>Fragrance: {device.scenxus.fragrance}</div>}
            </Table.Cell>
            <Table.Cell>
                {device.scenxus && (
                    <div>
                        <div className={styles.row}>
                            <div>{device.connectionStatus === 'Online' ? <div className={styles.on} /> : <div className={styles.off} />}</div>
                            <div>{device.connectionStatus}</div>
                        </div>
                        {device.connectedAt && <div>{Moment(device.connectedAt).fromNow()}</div>}
                    </div>
                )}
            </Table.Cell>
            <Table.Cell>
                <FragranceRemaining fragranceRemaining={fragrancePercentRemaining} />
            </Table.Cell>
            <Table.Cell>
                {device.scenxus && (
                    <div className={styles.row}>
                        <div className={styles[modeOn ? 'on' : 'off']} />
                        <div>{mode}</div>
                    </div>
                )}
            </Table.Cell>
            <Table.Cell>{device.scenxus && <Intensity device={device} />}</Table.Cell>
            <Table.Cell>
                {device.scenxus && (
                    <div className={styles.row}>
                        <div className={styles[`offCycle-${device.scenxus.cycle}`]} />
                        <div>{cycle}</div>
                    </div>
                )}
            </Table.Cell>
            <Table.Cell>
                {device.scenxus && device.scenxus.fan > 0 ? (
                    <div className={styles.row}>
                        <div className={styles[`fan-${device.scenxus.fan}`]} />
                        <div>{device.scenxus.fan}</div>
                    </div>
                ) : device.scenxus ? (
                    'N/A'
                ) : null}
            </Table.Cell>
        </Table.Row>
    )
}

Device.propTypes = {
    device: PropTypes.object.isRequired,
}

export default Device
